export const SHOW_PROMPTER = 'prompter/show-prompter';

export const HIDE_PROMPTER = 'prompter/hide-prompter';

export const SET_PROMPT_TITLE = 'prompter/set-prompt-caption';

export const SET_PROMPT_DESC = 'prompter/set-prompt-description';

export const SET_PROMPT_CHOICES = 'prompter/set-prompt-choices';

export const SET_PROMPT_PROMISE = 'prompter/set-prompt-promise';

export const SET_PROMPT_ANSWER = 'prompter/set-prompt-answer';

export const RESET_PROMPT_PROPS = 'prompter/reset-prompter-props';
